import React, { useEffect, useState } from 'react';
import { ROUTES_PATH } from '../../constants';
// image
import pepperLogo from '../../assets/images/pepper-one.svg';
import arrowLeft from '../../assets/images/arrow-left.svg';
import closeIcon from '../../assets/images/close.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  CloseIcon,
  HeaderContainer,
  HeaderIcons,
  HeaderLogo,
  HeaderSection,
  PepperLogo,
  ReturnIcon,
} from './StyledComponents';
import AnalyticsService from '../../services/Analytics';
import AnalyticsHelper from '../../utils/analyticsHelper';
import dayjs from 'dayjs';

interface HeaderProps {
  closeButton: boolean;
  removeArrow: boolean;
  bankreaderArrow: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  closeButton,
  removeArrow,
  bankreaderArrow,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const showArrow = () => {
    return (
      (location.pathname === ROUTES_PATH.PERSONAL_DATA && !removeArrow) ||
      bankreaderArrow
    );
  };

  const handleReturn = () => {
    if (bankreaderArrow) {
      const bankreaderIframe = document.getElementById(
        'pepper-bankreader-iframe'
      ) as HTMLIFrameElement;
      if (bankreaderIframe?.contentWindow) {
        const objMessage = {
          type: 'PEPPER_ONE',
          message: 'return',
        };
        bankreaderIframe?.contentWindow.postMessage(objMessage, '*');
      }
    } else {
      AnalyticsService.backEntry(AnalyticsHelper.getTimeElapse({ initTime: dayjs(), finishTime: dayjs()}));
      navigate(ROUTES_PATH.ENTRY, { state: { origin: 'personalData' } });
    }
  };

  const handleQuit = () => {
    const step_number = AnalyticsHelper.getStepLocation(location.pathname);
    AnalyticsService.sendTryExit(step_number);
    navigate(ROUTES_PATH.QUIT);
  };

  return (
    <HeaderContainer>
      <HeaderSection>
        {showArrow() && (
          <ReturnIcon
            id="header-return-btn"
            src={arrowLeft}
            onClick={handleReturn}
          />
        )}
      </HeaderSection>
      <HeaderLogo>
        <PepperLogo src={pepperLogo} />
      </HeaderLogo>
      <HeaderIcons>
        {ROUTES_PATH.QUIT === location.pathname ||
        ROUTES_PATH.DENIAL === location.pathname ||
        ROUTES_PATH.CANCEL === location.pathname ||
        ROUTES_PATH.COUNTER_OFFER === location.pathname ||
        ROUTES_PATH.END === location.pathname ||
        !closeButton ? (
          ''
        ) : (
          <CloseIcon
            id="header-close-btn"
            src={closeIcon}
            onClick={handleQuit}
          ></CloseIcon>
        )}
      </HeaderIcons>
    </HeaderContainer>
  );
};

export default Header;
